import { createBrowserRouter } from 'react-router-dom';

import * as Sentry from '@sentry/react';

import { NotFound } from '@pages/404';
import ModuleRoutes from '@routes/ModuleRoutes';

import { ROUTES } from '@constants';

export const router = Sentry.wrapCreateBrowserRouter(createBrowserRouter)(
  [
    ModuleRoutes,
    {
      path: ROUTES.ALL,
      element: <NotFound />,
    },
  ],
  {
    future: {
      v7_fetcherPersist: true,
      v7_startTransition: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
      v7_normalizeFormMethod: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);
